import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import { Button, Card, CardContent, CardActions, Container, Typography } from '@material-ui/core';
import { LockOutline } from "mdi-material-ui";
import logo2 from './../images/ggcLogo2.png';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        alignContent: 'center',
        height: '90vh',
        width: '100%'
    },
    pageTitleDiv: {
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        margin: 'auto',
        textAlign: 'center',
        padding: 30
    },
}));

export default function Unauthorized() {
    const classes = useStyles();
    const history = useHistory();
    const queryParams = new URLSearchParams(window.location.search)
    const err = queryParams.get("err")
    const msg = queryParams.get("msg")
    const uri = queryParams.get("uri")
    const mail = queryParams.get("mail")
    const user = queryParams.get("user")
    const name = queryParams.get("name")
    const token = queryParams.get("token")

    return (
        <Container className={classes.container}>
            <Card className={classes.pageTitleDiv}>
                <CardContent>
                    <img style={{ minWidth: 180, maxWidth: 200 }} src={logo2} alt="PTT GGC" />
                    <Typography variant='h4' gutterBottom>
                            Unauthorized
                    </Typography>
                    <LockOutline style={{fontSize: '200px'}} />
                    <Typography variant='body1'>
                        If this is a mistake, please contact your administrator.
                        {err ? <><br /><span>(Error: {err})</span></> : <></>}
                        {msg ? <><br /><span>(Message: {msg})</span></> : <></>}
                        {uri ? <><br /><span>(URI: {uri})</span></> : <></>}
                        {mail ? <><br /><span>[Email: {mail}]</span></> : <></>}
                        {user ? <><br /><span>[Username: {user}]</span></> : <></>}
                        {name ? <><br /><span>[Name: {name}]</span></> : <></>}
                        {token ? <><br /><span>[Token: {token}]</span></> : <></>}
                    </Typography>
                </CardContent>
                <CardActions style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                    <Button variant='contained' fullWidth color='default' onClick={() => history.push('/')}>
                        Home
                    </Button>
                </CardActions>
            </Card>
        </Container>
    )
}